


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"



window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  sharedComponents: [
    {
      name: "@sparta.stepup.shared-components/ah-authcode-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/stepup-ah-authcode-shared-component-es6" */ "@sparta.stepup.shared-components/ah-authcode-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-security-preference-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-security-preference-shared-component-es6" */ "@sparta.login.shared-components/ah-security-preference-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-secure-signin-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-secure-signin-shared-component-es6" */ "@sparta.login.shared-components/ah-secure-signin-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.stepup.shared-components/ah-u2f-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/stepup-ah-u2f-shared-component-es6" */ "@sparta.stepup.shared-components/ah-u2f-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.stepup.shared-components/ah-add-contact-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/stepup-ah-add-contact-shared-component-es6" */ "@sparta.stepup.shared-components/ah-add-contact-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.stepup.shared-components/ah-cq-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/stepup-ah-cq-shared-component-es6" */ "@sparta.stepup.shared-components/ah-cq-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.splash.shared-components/ah-eftx-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/splash-ah-eftx-shared-component-es6" */ "@sparta.splash.shared-components/ah-eftx-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-ecd-sa-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-ecd-sa-shared-component-es6" */ "@sparta.login.shared-components/ah-ecd-sa-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-spinner",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-spinner-es6" */ "@sparta.global.shared-components/spa-vue-spinner/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-messaging",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-messaging-es6" */ "@sparta.global.shared-components/spa-vue-messaging/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-button",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-button-es6" */ "@sparta.global.shared-components/spa-vue-button/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-badging",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-badging-es6" */ "@sparta.global.shared-components/spa-vue-badging/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-svg",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-svg-es6" */ "@sparta.global.shared-components/spa-vue-svg/dist/es6.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-change-passcode-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-change-passcode-shared-component-es6" */ "@sparta.login.shared-components/ah-change-passcode-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-change-credentials-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-change-credentials-shared-component-es6" */ "@sparta.login.shared-components/ah-change-credentials-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-change-oid-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-change-oid-shared-component-es6" */ "@sparta.login.shared-components/ah-change-oid-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-sb-amlcip-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-sb-amlcip-shared-component-es6" */ "@sparta.login.shared-components/ah-sb-amlcip-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-cq-pref-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-cq-pref-shared-component-es6" */ "@sparta.login.shared-components/ah-cq-pref-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-catch-all-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-catch-all-shared-component-es6" */ "@sparta.login.shared-components/ah-catch-all-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.login.shared-components/ah-passkey-signin-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/login-ah-passkey-signin-shared-component-es6" */ "@sparta.login.shared-components/ah-passkey-signin-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.stepup.shared-components/ah-digital-id-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/stepup-ah-digital-id-shared-component-es6" */ "@sparta.stepup.shared-components/ah-digital-id-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.authglobal.shared-components/ah-quick-help-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/authglobal-ah-quick-help-shared-component-es6" */ "@sparta.authglobal.shared-components/ah-quick-help-shared-component/dist/es6.js" )}
    }
  ],
  stores: [
    {
      namespace: "@sparta.global-tenants.stores/gt-unauth-bootstrap-store",
                   loader: function() { return import( /* webpackChunkName: "spa-assets/js/stores/@sparta.global-tenants.stores/gt-unauth-bootstrap-store-es6" */ "@sparta.global-tenants.stores/gt-unauth-bootstrap-store/dist/es6.js" )}
    }
  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
  console.log('after - execute boot functions')
})();
